<template>
    <div>
        <template>
            {{refreshLic}}
            <div class="" v-if="(form.TipoTema == 'DIRECTORIO')">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <h3 v-if="(form.TipoTema == 'DIRECTORIO' && form.Titulo != '')" class="color_Azul family-01 mb-3">{{form.Titulo}}</h3>
                        <hr v-if="(form.TipoTema == 'DIRECTORIO' && form.Titulo != '')" class="divider-02 hr-sm-left-0 bg-color">
                        <h5 v-show="(form.Subtitulo !='')" class="color_Azul">{{form.Subtitulo}}</h5>
                    </div>
                </div>

                <div class="row justify-content-center" v-if="(form.contactosTema.length>1)">
                    <div class="col-12 col-sm-12 col-md-10 col-lg-6 col-xl-6" v-for="(detalle,key5) in form.contactosTema" :key="key5">
                        <div class="row pointer" @click="get_one(detalle.IdDirectorio)">
                            <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                                <div class="avatar-padre">
                                    <div class="avatar-hijo">
                                        <figure class="box-imge">
                                            <img :src="(detalle.Imagen!='')?RutaFileD+detalle.Imagen:''" v-show="(detalle.Imagen!='')" :alt="detalle.Nombre">
                                        </figure>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                                <div class="avatar-padre">
                                    <div class="avatar-hijo">
                                        <h5>{{detalle.Nombre}}</h5>
                                        <span>
                                            <b>{{detalle.NomPuesto}}</b>
                                            <template v-if="detalle.DescripPuesto != ''">
                                                {{', '+detalle.DescripPuesto}}
                                            </template>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="avatar-item">
                            <div class="down-content">
                                <ul>
                                    <li><b>Correo:</b>
                                        <a class="" :href="'mailto:'+detalle.Correo">{{detalle.Correo}}</a>
                                    </li>
                                    <li v-if="detalle.Correo2 != '' && detalle.Correo2!=null">
                                        <b>Correo:</b> <a :href="'mailto:'+detalle.Correo2"> {{detalle.Correo2}}</a>
                                    </li>
                                    <li v-if="detalle.Telefono != '' && detalle.Telefono!=null">
                                        <b>Tel.:</b> <a :href="'tel:+'+detalle.Telefono">{{detalle.Telefono}}</a>
                                    </li>
                                    <li v-if="detalle.Horario != '' && detalle.Horario!=null">
                                        <b>Hor.:</b>{{detalle.Horario}}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mb-5 justify-content-center" v-else>
                    <div class="col-12 col-sm-12 col-md-10 col-lg-7 col-xl-7" v-for="(detalle,key5) in form.contactosTema" :key="key5">
                        <div class="row justify-content-center">
                            <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                                <div class="avatar-padre">
                                    <div class="avatar-hijo">
                                        <figure class="box-imge">
                                            <img :src="(detalle.Imagen!='')?RutaFileD+detalle.Imagen:''" v-show="(detalle.Imagen!='')" :alt="detalle.Nombre">
                                        </figure>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                                <div class="avatar-padre">
                                    <div class="avatar-hijo">
                                        <h5>{{detalle.Nombre}}</h5>
                                        <span>
                                            <b>{{detalle.NomPuesto}}</b>
                                            <template v-if="detalle.DescripPuesto != ''">
                                                {{', '+detalle.DescripPuesto}}
                                            </template>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="avatar-item">
                            <div class="down-content">
                                <ul>
                                    <li><b>Correo:</b>
                                        <a class="" :href="'mailto:'+detalle.Correo">{{detalle.Correo}}</a>
                                    </li>
                                    <li v-if="detalle.Correo2 != '' && detalle.Correo2!=null">
                                        <b>Correo:</b> <a :href="'mailto:'+detalle.Correo2"> {{detalle.Correo2}}</a>
                                    </li>
                                    <li v-if="detalle.Telefono != '' && detalle.Telefono!=null">
                                        <b>Tel.:</b> <a :href="'tel:+'+detalle.Telefono">{{detalle.Telefono}}</a>
                                    </li>
                                    <li v-if="detalle.Horario != '' && detalle.Horario!=null">
                                        <b>Hor.:</b>{{detalle.Horario}}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        
        <modal-component v-if="showModal" @cerrar="showModal = false" size='modal-lg'>
			<template slot="titulo" >
                Semblanza
            </template>
			<template slot="contenido" >
                <h3 class="color_Azul family-01 mb-3">{{Directorio.Nombre}}</h3>
                <hr class="divider-02 hr-sm-left-0 bg-color">
                
                <img :src="Directorio.Img" :alt="Directorio.Nombre" class="parrafo-img img-thumbnail">
                <p class="text-justify">
                    <template>
                        <div class="text-justify list-icon" v-html="Directorio.Biografia"></div>
                    </template>
                </p>
			</template>
		</modal-component>

    </div>
</template>
<script>
import ModalComponent from "@/components/ModalComponent";

export default {
    components:{
        ModalComponent
    },
    props:['value','RutaFile','listIconos','Tipo'],
    data() {
        return {
            form:this.value,
            showModal:false,
            Directorio:{
                Img:'',
                Nombre:'',
                Biografia:''
            },
            RutaFileD: '',
        }
    },methods: {
        get_one(Id)
        {
            this.$http.get('directorio/recovery',
                {
                    params:{IdDirectorio: Id}
                })
                .then(res => {
                    
                    this.Directorio.Img = res.data.RutaFile+res.data.data.directorio.Imagen;
                    this.Directorio.Nombre = res.data.data.directorio.Nombre +' '+res.data.data.directorio.Apellidos;
                    this.Directorio.Biografia = res.data.data.directorio.Biografia;
                    this.showModal = true;
                    
                    
                });
        },
    },
    computed:{
        refreshLic: function(){
            this.RutaFileD = this.RutaFile;
        }
    }
}
</script>